import React, { useState, useEffect } from 'react';
import {
    User,
    Building,
    Mail,
    Phone,
    Calendar,
    Users,
    MoreVertical,
    Edit,
    Trash2
} from 'lucide-react';

const ReferentCustomer = ({ searchKey, idCustomer }) => {
    const [referents, setReferents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [dropdownOpen, setDropdownOpen] = useState(null);

    // Fonction pour récupérer les référents
    const fetchReferents = async () => {
        try {
            setLoading(true);
            setError(null);

            const response = await fetch('https://search.mg.formafusion.io/api/search/referent-customers', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({
                    key: searchKey,
                    idCustomer: idCustomer,
                }),
            });

            if (!response.ok) {
                throw new Error(`Erreur HTTP: ${response.status}`);
            }

            const data = await response.json();
            setReferents(data);
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (searchKey && idCustomer) {
            fetchReferents();
        }
    }, [searchKey, idCustomer]);

    // Handlers pour les actions
    const editReferent = (id) => {
        setDropdownOpen(null);
    };

    const deleteReferent = async (id) => {
        if (window.confirm('Êtes-vous sûr de vouloir supprimer ce référent ?')) {
            try {
                await fetchReferents();
            } catch (error) {
            }
        }
        setDropdownOpen(null);
    };

    const toggleDropdown = (id) => {
        setDropdownOpen(dropdownOpen === id ? null : id);
    };

    // Fermer le dropdown quand on clique ailleurs
    useEffect(() => {
        const handleClickOutside = () => {
            setDropdownOpen(null);
        };

        if (dropdownOpen) {
            document.addEventListener('click', handleClickOutside);
            return () => document.removeEventListener('click', handleClickOutside);
        }
    }, [dropdownOpen]);

    // Composant de chargement
    if (loading) {
        return (
            <div className="flex items-center justify-center h-64">
                <div className="w-12 h-12 border-b-2 border-indigo-600 rounded-full animate-spin"></div>
            </div>
        );
    }

    // Composant d'erreur
    if (error) {
        return (
            <div className="p-4 text-center text-red-500">
                <p>Erreur: {error}</p>
                <button
                    onClick={fetchReferents}
                    className="px-4 py-2 mt-2 text-white bg-indigo-600 rounded hover:bg-indigo-700"
                >
                    Réessayer
                </button>
            </div>
        );
    }

    // Aucun référent trouvé
    if (!referents || referents.length === 0) {
        return (
            <div className="p-8 text-center text-gray-500">
                <User className="w-12 h-12 mx-auto mb-4 text-gray-400" />
                <p>Aucun référent trouvé pour "{searchKey}".</p>
            </div>
        );
    }

    return (
        <div className="container p-6 mx-auto">
            <div className="flex items-center justify-between mb-6">
                <h1 className="text-2xl font-semibold text-gray-800">
                    Vous avez {referents.length} Référent{referents.length > 1 ? 's' : ''} des clients
                </h1>
                <button
                    onClick={fetchReferents}
                    className="px-4 py-2 text-white transition-colors bg-indigo-600 rounded-lg hover:bg-indigo-700"
                >
                    Actualiser
                </button>
            </div>

            <section className="mt-4">
                <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 sm:grid-cols-2">
                    {referents.map((referent) => (
                        <div key={referent.id} class="w-full p-3 bg-white shadow-xl h-96 border-[1px] border-slate-200 rounded-xl">
                            <div class="flex flex-col w-full h-full gap-2">
                                <div class="w-full h-1/2">
                                    <div class="inline-flex items-start justify-between w-full">
                                        <div class="flex flex-col items-start gap-1">
                                            <div class="flex items-center justify-center text-3xl font-medium text-gray-500 uppercase bg-gray-100 rounded-full w-28 h-28">
                                                <img src={`https://formafusionmg.ams3.cdn.digitaloceanspaces.com/formafusionmg/img/referents/${referent.photo}`} alt="photo" class="object-cover w-full h-full rounded-full" />
                                            </div>
                                            <p class="flex-wrap text-lg font-medium text-gray-700">{referent.name} {referent.firstName}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-full bg-slate-100 h-1/2 rounded-xl">
                                    <div class="flex flex-col h-full gap-2 p-3">
                                        <div class="w-full h-1/2">
                                            <div class="grid grid-cols-5">
                                                <div class="grid col-span-3 grid-cols-subgrid">
                                                </div>
                                                <div class="grid col-span-2 grid-cols-subgrid">
                                                    <div class="flex flex-col">
                                                        <span class="text-gray-400">Matricule</span>
                                                        <span class="text-gray-500">{referent.matricule}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="flex flex-col w-full gap-1 h-1/2">
                                            <div class="inline-flex space-x-2 items-center gap-1">
                                                <div class="w-[18px]">
                                                    <Mail></Mail>
                                                </div>
                                                <p class="text-gray-500">{referent.email}</p>
                                            </div>
                                            <div class="inline-flex space-x-2 items-center gap-1">
                                                <div class="w-[18px]">
                                                    <Phone></Phone>
                                                </div>
                                                <p class="text-gray-500">{referent.phone}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default ReferentCustomer;